export const badge: any = {
  py: 'xxs',
  px: 'xs',
  bg: 'primary',
  color: 'white',
  fontWeight: 'bold',
  lineHeight: 'default',
  letterSpacing: 'caps',
  css: {
    height: 'auto', // to reset the default height
    fontSize: 14,
    textAlign: 'center',
    borderRadius: '4px',
    textTransform: 'uppercase',
    fontFeatureSettings: '"cpsp" on, "case" on',
    paddingTop: '2px',
    paddingBottom: '2px'
  },
  variants: {
    endpoint: {
      css: ({ theme }: any) => ({
        backgroundColor: '#EEECFE',
        color: '#1A1A60'
      })
    },
    model: {
      css: ({ theme }: any) => ({
        backgroundColor: '#DFEBC4',
        color: '#2C4D21'
      })
    },
    mapping: {
      css: ({ theme }: any) => ({
        backgroundColor: '#FFF3BD',
        color: '#653804'
      })
    },
    flow: {
      css: ({ theme }: any) => ({
        backgroundColor: '#EECDD0',
        color: '#521015'
      })
    },
    error: {
      bg: 'error'
    },
    success: {
      css: ({ theme }: any) => ({
        backgroundColor: '#569640',
        color: theme.colors.white
      })
    },
    warning: {
      css: ({ theme }: any) => ({
        backgroundColor: '#BDC0D0',
        color: theme.colors.white
      })
    },
    active: {
      css: ({ theme }: any) => ({
        backgroundColor: '#2B2D3B',
        color: theme.colors.black
      })
    },
    inactive: {
      css: ({ theme }: any) => ({
        backgroundColor: '#BDC0D0',
        color: theme.colors.white
      })
    },
    account: {
      css: ({ theme }: any) => ({
        backgroundColor: '#3D4051',
        color: '#BDC0D0',
        textTransform: 'none'
      })
    },
    round: {
      css: ({ theme }: any) => ({
        borderRadius: '50%',
        width: '22px',
        height: '22px',
        backgroundColor: 'white',
        color: 'Inherent'
      })
    },
    new: {
      css: ({ theme }: any) => ({
        backgroundColor: '#3D4051',
        color: '#BDC0D0',
        textTransform: 'none'
      })
    },
    draft: {
      css: ({ theme }: any) => ({
        backgroundColor: '#f8d677',
        color: '#1d1f23',
        textTransform: 'none'
      })
    },
    published: {
      css: ({ theme }: any) => ({
        backgroundColor: '#f8d677',
        color: '#BDC0D0',
        textTransform: 'none'
      })
    },
    deployed: {
      css: ({ theme }: any) => ({
        backgroundColor: '#3D4051',
        color: '#BDC0D0',
        textTransform: 'none'
      })
    }
  }
};
